export const TOLERANCIA_DIF_IVA_PERCEPCION = Number(1)
